import { deepExtract } from 'helpers/deep';
import { CORPORATE_JUSTWORKS_REGEX, CORPORATE_PLAN_REGEX } from 'constants/corporate';
import { COMEMBERSHIP, ALLOW_PREPAID_CARDS_PLANS } from 'constants/plan-types';

const CLUB_CLASSES_NUMBERS = [0, 1];

export default class PlanDeriver {
  static nonClubPlans(plans) {
    return plans.filter(plan => CLUB_CLASSES_NUMBERS.indexOf(plan.reservations_per_cycle) === -1);
  }

  static augmentCurrentPlan(plan) {
    return { ...plan, current: true };
  }

  static comembershipDetails(plan = {}) {
    return {
      termsLink: deepExtract('display_metadata.additional_terms.link', plan, null),
      termsTitle: deepExtract('display_metadata.additional_terms.title', plan, null),
      banner: deepExtract('display_metadata.banner', plan, null),
      cardDetail: deepExtract('display_metadata.card_detail', plan, null),
    };
  }

  static isUpgrade(oldPlan, newPlan) {
    return oldPlan.price < newPlan.price;
  }

  static cheapestPlan(plans) {
    return plans.reduce((cheapest, plan) => {
      if (!cheapest || plan.price < cheapest.price) {
        return plan;
      }
      return cheapest;
    }, null);
  }

  static isComembershipPlan(plan = {}) {
    const { type } = plan;

    return !!type && type === COMEMBERSHIP;
  }

  static filterPlans(plans, rules = []) {
    if (!plans || !rules || !rules.length) {
      return plans;
    }

    return plans.filter(plan => rules.some(expr => !new RegExp(expr).test(plan.plan_code)));
  }

  static isLiveNoHardware(planMode) {
    return planMode.substr(-12) === '_no_hardware';
  }

  static isAllowPrepaidCards(plan = {}) {
    return !!plan && ALLOW_PREPAID_CARDS_PLANS.indexOf(plan.plan_code) > -1;
  }

  static isCorporateJustworks(planCode) {
    return planCode && CORPORATE_JUSTWORKS_REGEX.test(planCode);
  }

  static isCorporatePlan(plan) {
    const planCode = deepExtract('plan_code', plan, '');
    return CORPORATE_PLAN_REGEX.test(planCode) || CORPORATE_JUSTWORKS_REGEX.test(planCode);
  }
}
